const isProduction = process.env.NODE_ENV === "production";

export function setLogging(enable) {
  if (isProduction || (!isProduction && enable)) {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.debug = () => {};
  }
}
